import React, { FC } from 'react';
import { Otp2Form } from 'src/shared/components/otp2-form/otp2-form';

export const Otp2Page: FC = () => <Otp2Form />;
